import React from "react";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/js/custom.js";
import { BrowserRouter as Router, Routes, Route, HashRouter, Navigate } from "react-router-dom";
import PrivateRoute from "./component/Routes/PrivateRoute";
import BookingCreate from "./views/Booking/BookingCreate";
import BookingDetails from "./views/Booking/BookingDetails";
import Login from "./views/Login/Login";
import BookingSummary from "./views/Booking/BookingSummary.js";
import BookingList from "./views/Booking/BookingList.js";
import MakePayment from "./views/Booking/MakePayment.js";
import CustomerResgistration from "./views/Booking/CustomerResgistration";
import BookingReceipt from "./views/Booking/BookingReceipt.js";
import Privateroute from "./utils/Privateroute.js";
import Publicroute from "./utils/Publicroute.js";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { NotificationProvider } from "./context/NotificationContext";
import NotificationList from "./views/Notification/NotificationList";

const theme = createTheme({
  typography: {
    fontFamily: "'Inter', 'Poppins', sans-serif",
  },
});

function App() {

  // const token = localStorage.getItem('prime_access_token');
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <Router basename={process.env.PUBLIC_URL}>
            <Routes>
              <Route element={<Publicroute />}> 
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path='/customer-registration' element={<CustomerResgistration />} />
              </Route>
              <Route element={<Privateroute />}> 
                <Route path='/booking-create' element={<BookingCreate />} />
                <Route path='/booking-summary' element={<BookingSummary />} />
                <Route path='/booking-list' element={<BookingList />} />
                <Route path='/booking-receipt' element={<BookingReceipt />} />
                <Route path='/payment-details' element={<MakePayment />} />
                <Route path='/booking-details' element={<BookingDetails />} />
                <Route path='/notification-list' element={<NotificationList />} />
              </Route>
            </Routes>
        </Router>
      </NotificationProvider>
    </ThemeProvider>
  );
}
 
export default App;
